import getDefaultFolderIdToLoad from './helpers/getDefaultFolderIdToLoad';
import selectFolder from './selectFolder';
import { isFolderInFavorites } from 'owa-favorites';
import { FolderForestTreeType } from 'owa-favorites-types';
import { action } from 'satcheljs/lib/legacy';

export default action('selectDefaultFolder')(function selectDefaultFolder(): void {
    const defaultFolderIdToLoad = getDefaultFolderIdToLoad();
    const treeType: FolderForestTreeType = isFolderInFavorites(defaultFolderIdToLoad)
        ? 'favorites'
        : 'primaryFolderTree';
    selectFolder(defaultFolderIdToLoad, treeType, 'NonUserAction' /* ActionSource */);
});
